const recyclingData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133790/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_c7aaaba5-c5e8-42d9-a4dd-fda822cec081_mk5cjr.png',
  priceAssessmentsBrochureFile: {
    file_name: 'Benchmark-Recycling-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'blackMassPriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureRecyclingFilePdfID',
    file_name: 'Recycling Forecast Brochure.pdf',
    category: 'public-documents',
  },
  banner: {
    title:
      'Our quarterly service provides a detailed assessment of lithium-ion battery recycling including:',
    descriptions: [
      {
        items: [
          'Comprehensive <strong>assessment</strong> of the <strong>global feedstock</strong> of recyclable material',
          '<strong>Key battery materials</strong> recovered via <strong>battery recycling</strong>',
          '<strong>Recycling capability</strong>, in terms of <strong>capacity and technology</strong>, by major player and region',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719604543/assets/data-reports/recycling/1_ek1unb.png',
        alt: 'Recycling Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719604544/assets/data-reports/recycling/2_umsmex.png',
        alt: 'Recycling Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719604543/assets/data-reports/recycling/3_hpjev2.png',
        alt: 'Recycling Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1719604545/assets/data-reports/recycling/4_i1bq5n.png',
      title:
        'Access the Recycling Forecast’s granular analysis of the battery recycling market:',
      descriptions: [
        {
          items: [
            '<strong>Recycling scrap pool</strong>: data on the pool of recyclable material assessed by source (end-of-life material and process scrap), battery application, region, and cathode chemistry, out to 2040',
            '<strong>Review of recycled materials</strong>: a breakdown of recycled lithium, nickel, and cobalt, by region and scrap pool type',
            '<strong>Technology profiles</strong>: explore and understand the characteristics of dominant recycling technologies employed by market players',
            '<strong>Partnerships tracker</strong>: keep up to date with the latest partnership developments across the battery recycling landscape',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1719604545/assets/data-reports/recycling/5_ku0ckc.png',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Recycling Forecast:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong>: downloads available each quarter',
            '<strong>Clear and Concise</strong>: Your data is presented in Excel and PDF format',
            '<strong>Implement Your Ideas</strong> : Each file is fully customisable so you can input your own assumptions',
          ],
        },
      ],
    },
  },
}

export default recyclingData
